var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('preloader'),_c('v-main',{staticClass:"fill-height"},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1),_c('alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }